export type AuthConfig = {
  user_pool_id: string;
  client_id: string;
  region: string;
};

let cached: AuthConfig | null = null;

export async function getAuthConfig(): Promise<AuthConfig | null> {
  if (cached) return cached;
  try {
    const res = await fetch("/auth/config");
    if (!res.ok) return null;
    const data = (await res.json()) as AuthConfig;
    if (data.user_pool_id && data.client_id && data.region) {
      cached = data;
      return cached;
    }
  } catch {
    // ignore
  }
  return null;
}
